import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Text, VStack, NativeSelect } from '@chakra-ui/react';
import { LocationInput, LocationInputPlace } from '@src/components/sco/LocationInput';
import { gql } from '@src/lib/gql';
import React, { useState } from 'react';
export const LocationSelectAndDistanceInput = props => {
  const $ = _c(63);
  const [distanceInMiles, setDistanceInMiles] = useState(props.defaultValues?.distanceInMiles || "500");
  const [country, setCountry] = useState(props.defaultValues?.country || "");
  const [region, setRegion] = useState(props.defaultValues?.region || "");
  const [place, setPlace] = useState(props.defaultValues?.place || null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      {
        scoInvestorProfileSearchOptions {
          id
          allRegions
          allCountries
        }
      }
    `;
    t1 = {
      ssr: false
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const optionsQuery = useQuery(t0, t1);
  let t2;
  if ($[2] !== optionsQuery.data?.scoInvestorProfileSearchOptions?.allRegions) {
    t2 = optionsQuery.data?.scoInvestorProfileSearchOptions?.allRegions || [];
    $[2] = optionsQuery.data?.scoInvestorProfileSearchOptions?.allRegions;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const regionOptions = t2;
  let t3;
  if ($[4] !== optionsQuery.data?.scoInvestorProfileSearchOptions?.allCountries) {
    t3 = optionsQuery.data?.scoInvestorProfileSearchOptions?.allCountries || [];
    $[4] = optionsQuery.data?.scoInvestorProfileSearchOptions?.allCountries;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const countryOptions = t3;
  let t4;
  if ($[6] !== props) {
    t4 = value => {
      setPlace(value);
      if (props.onPlaceChange) {
        props.onPlaceChange(value);
      }
    };
    $[6] = props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handlePlaceChange = t4;
  let t5;
  if ($[8] !== props) {
    t5 = event => {
      const value_0 = event.target.value;
      setDistanceInMiles(value_0);
      props.onDistanceChange(value_0);
    };
    $[8] = props;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleDistanceInputChange = t5;
  let t6;
  if ($[10] !== props) {
    t6 = event_0 => {
      const value_1 = event_0.target.value;
      setRegion(value_1);
      if (props.onRegionChange) {
        props.onRegionChange(value_1);
      }
    };
    $[10] = props;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleRegionInputChange = t6;
  let t7;
  if ($[12] !== props) {
    t7 = event_1 => {
      const value_2 = event_1.target.value;
      setCountry(value_2);
      if (props.onCountryChange) {
        props.onCountryChange(value_2);
      }
    };
    $[12] = props;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleCountryInputChange = t7;
  let t8;
  if ($[14] !== props.label) {
    t8 = props.label && <Text marginBottom={4} textStyle="label2xs">{props.label}</Text>;
    $[14] = props.label;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t10;
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = ["(cities)"];
    t10 = {
      inputProps: {}
    };
    $[16] = t10;
    $[17] = t9;
  } else {
    t10 = $[16];
    t9 = $[17];
  }
  let t11;
  if ($[18] !== handlePlaceChange || $[19] !== place) {
    t11 = <LocationInput defaultValue={place} placeTypes={t9} comboboxTagInputProps={t10} onChange={handlePlaceChange} />;
    $[18] = handlePlaceChange;
    $[19] = place;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <option value="25">Within 25 Miles</option>;
    t13 = <option value="50">Within 50 Miles</option>;
    t14 = <option value="100">Within 100 Miles</option>;
    t15 = <option value="250">Within 250 Miles</option>;
    t16 = <option value="500">Within 500 Miles</option>;
    t17 = <option value="1000">Within 1,000 Miles</option>;
    t18 = <option value="2500">Within 2,500 Miles</option>;
    t19 = <option value="3000">Within 3,000 Miles</option>;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
    $[26] = t17;
    $[27] = t18;
    $[28] = t19;
  } else {
    t12 = $[21];
    t13 = $[22];
    t14 = $[23];
    t15 = $[24];
    t16 = $[25];
    t17 = $[26];
    t18 = $[27];
    t19 = $[28];
  }
  let t20;
  if ($[29] !== distanceInMiles || $[30] !== handleDistanceInputChange) {
    t20 = <NativeSelect.Field value={distanceInMiles} onChange={handleDistanceInputChange}>{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}</NativeSelect.Field>;
    $[29] = distanceInMiles;
    $[30] = handleDistanceInputChange;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <NativeSelect.Indicator />;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t20) {
    t22 = <NativeSelect.Root>{t20}{t21}</NativeSelect.Root>;
    $[33] = t20;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <option value="">Any Country</option>;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== countryOptions) {
    t24 = countryOptions.map(_temp);
    $[36] = countryOptions;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== country || $[39] !== handleCountryInputChange || $[40] !== t24) {
    t25 = <NativeSelect.Field value={country} onChange={handleCountryInputChange}>{t23}{t24}</NativeSelect.Field>;
    $[38] = country;
    $[39] = handleCountryInputChange;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <NativeSelect.Indicator />;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t25) {
    t27 = <NativeSelect.Root>{t25}{t26}</NativeSelect.Root>;
    $[43] = t25;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <option value="">Any Region</option>;
    $[45] = t28;
  } else {
    t28 = $[45];
  }
  let t29;
  if ($[46] !== regionOptions) {
    t29 = regionOptions.map(_temp2);
    $[46] = regionOptions;
    $[47] = t29;
  } else {
    t29 = $[47];
  }
  let t30;
  if ($[48] !== handleRegionInputChange || $[49] !== region || $[50] !== t29) {
    t30 = <NativeSelect.Field value={region} onChange={handleRegionInputChange}>{t28}{t29}</NativeSelect.Field>;
    $[48] = handleRegionInputChange;
    $[49] = region;
    $[50] = t29;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <NativeSelect.Indicator />;
    $[52] = t31;
  } else {
    t31 = $[52];
  }
  let t32;
  if ($[53] !== t30) {
    t32 = <NativeSelect.Root>{t30}{t31}</NativeSelect.Root>;
    $[53] = t30;
    $[54] = t32;
  } else {
    t32 = $[54];
  }
  let t33;
  if ($[55] !== t11 || $[56] !== t22 || $[57] !== t27 || $[58] !== t32) {
    t33 = <VStack align="stretch" gap="0.25em" width="full">{t11}{t22}{t27}{t32}</VStack>;
    $[55] = t11;
    $[56] = t22;
    $[57] = t27;
    $[58] = t32;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t33 || $[61] !== t8) {
    t34 = <Box width="full">{t8}{t33}</Box>;
    $[60] = t33;
    $[61] = t8;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  return t34;
};
function _temp(option, idx) {
  return <option key={idx} value={option}>{option}</option>;
}
function _temp2(option_0, idx_0) {
  return <option key={idx_0} value={option_0}>{option_0}</option>;
}